import api from './api';

export const chatService = {
  // Create a new chat message
  createMessage: async (messageData) => {
    const response = await api.post('/api/chat/', messageData);
    return response.data;
  },

  // Get all messages for a case
  getCaseMessages: async (caseId, skip = 0, limit = 50) => {
    const response = await api.get(`/api/chat/case/${caseId}?skip=${skip}&limit=${limit}`);
    return response.data;
  },

  // Update a message (edit)
  updateMessage: async (messageId, messageData) => {
    const response = await api.put(`/api/chat/${messageId}`, messageData);
    return response.data;
  },

  // Delete a message
  deleteMessage: async (messageId) => {
    const response = await api.delete(`/api/chat/${messageId}`);
    return response.data;
  }
};